import React from 'react';
import CategoryBlock from '../components/CategoryBlock';
import {Link, withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';
import URLSearchParams from 'url-search-params';
import classNames from 'classnames';
import EditCategoryPopUp from '../components/EditCategoryPopup';
import DeleteCategoryPopUp from '../components/DeleteCategoryPopup';
import TutorialPopup from '../components/TutorialPopup';
import Courses from '../components/Courses';
import {CREATE_CATEGORY_TYPE} from 'constants/adminPupups';

const CATEGORIES_REQUEST = '/api/v1/categories/';
const COURSE_REQUEST = '/api/v1/courses';

@withRouter
@inject('userStore')
@inject('createCourseStore')
@inject('categoryStore')
@inject('editableCategoryStore')
@observer
export default class Categories extends React.Component {

  state = { singleMode: true };

  componentDidMount() {
    const { course } = this.props.createCourseStore;

    if(course && course.id) {
      this.getSelectedCourse();
    }
    // this.loadCategory(this.props.location);
    // this.routerListener = this.props.history.listen(location => {
    //  this.loadCategory(location);
    // });
  }

  getSelectedCourse = () => {
    const { createCourseStore: { course }, categoryStore: { setCategories } } = this.props;

    new HttpClient().get(`${COURSE_REQUEST}/${course.id}`).then(response => {
      setCategories(response.body.data.course.categories);
    });
  }

  loadCategory = pathname => {
    let urlParams = new URLSearchParams(pathname.search);
    const slug = urlParams.get('slug');
    if(slug) {
      this.setState({singleMode: true});
      new HttpClient().get(CATEGORIES_REQUEST + slug).then(response => {
        this.props.categoryStore.setCategory(response.body.data.category)
      });
    }
    else {
      this.setState({singleMode: false});

      new HttpClient().get(CATEGORIES_REQUEST).then(response => {
        this.props.categoryStore.setCategories(response.body.data.categories)
      });
    }
  };

  openCreatePopup = e => {
    e.preventDefault();
    this.props.editableCategoryStore.activate(CREATE_CATEGORY_TYPE, null);
  };

  isAdminCurrentUser = () => {
    return this.props.userStore.isAdmin();
  };

  componentWillUnmount(){
    // this.routerListener();
  }

  onCourseSelect = course => {
    this.props.createCourseStore.setCourse(course);
    this.getSelectedCourse();
  }

  render() {
    const { course } = this.props.createCourseStore;
    const sortedCategories = this.props.categoryStore.categories.sort((category_a, category_b) => category_a.title.localeCompare(category_b.title));
    const categories = sortedCategories.map( item => {
      return (
        <div className="category-preview"
             key={item.id}>
          <CategoryBlock
            singleMode={this.state.singleMode}
            itemId={item.id}
            slug={item.slug}
            title={item.title}
            video_amount={item.tutorials_count}
            type={item.type}
            isAdmin={this.isAdminCurrentUser()}/>
        </div>
      )
    });

    return (
      <section className="section categories">
        <ol className="breadcrumbs">
          {  this.props.userStore.user && <li className={classNames('breadcrumb-item', {active: !this.props.categoryStore.isSingle})}>
            <Link to="/dashboard">Dashboard</Link>
          </li>}
          {  !this.props.userStore.user && <li className={classNames('breadcrumb-item', {active: !this.props.categoryStore.isSingle})}>
            <Link to="/">Dashboard</Link>
          </li>}
          {this.props.categoryStore.isSingle &&
            <li className="breadcrumb-item active"><Link to="/categories">Tutorials</Link></li>
          }
        </ol>
        <div className="container-fluid">
          <div className="row justify-content-center">
            {this.isAdminCurrentUser() &&
            <button className="btn blue floating-btn  new-category-btn modal"
                    onClick={this.openCreatePopup}
                    disabled={course && !course.title}
                    type="button">+</button>
            }

            <Courses onCourseSelect={this.onCourseSelect} />
            {categories}
          </div>
        </div>
        <EditCategoryPopUp/>
        <DeleteCategoryPopUp/>
        <TutorialPopup/>
      </section>
    )
  }
}







// WEBPACK FOOTER //
// ./src/modules/categories/containers/Categories.js